"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sellProviders = exports.buyProviders = void 0;
const Banxa_1 = __importDefault(require("./Banxa/Banxa"));
const Mercuryo_1 = __importDefault(require("./Mercuryo/Mercuryo"));
const Moonpay_1 = __importDefault(require("./Moonpay/Moonpay"));
const Ramp_1 = __importDefault(require("./Ramp/Ramp"));
const Simplex_1 = __importDefault(require("./Simplex/Simplex"));
const Transak_1 = __importDefault(require("./Transak/Transak"));
const Alchemy_1 = __importDefault(require("./Alchemy/Alchemy"));
exports.buyProviders = {
    banxa: new Banxa_1.default(),
    moonpay: new Moonpay_1.default(),
    transak: new Transak_1.default(),
    mercuryo: new Mercuryo_1.default(),
    simplex: new Simplex_1.default(),
    alchemy: new Alchemy_1.default(),
    ramp: new Ramp_1.default(),
};
exports.sellProviders = {
    banxa: new Banxa_1.default(),
    moonpay: new Moonpay_1.default(),
    mercuryo: new Mercuryo_1.default(),
};
//# sourceMappingURL=providers.js.map